import React from "react";

import "./roadmap.css";

const Roadmap = () => {
    return (
        <div id="roadmap">
            <div id="roadmap-div">
                <h1>ROADMAP</h1>
                <div class="roadmap-subjects">
                    <div id="subjects">
                        <h2>Physics</h2>
                        <div id="units">
                            <div id="chapters">
                                <h4>I - Electrostatics</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 1 : Electric Charges and Fields
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 2 : Electrostatic Potential and
                                    Capacitance
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>II - Current Electricity</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 3 : Current Electricity
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>
                                    III - Magnetic Effect of Current & Magnetism
                                </h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 4 : Moving Charges and Magnetism
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 5 : Magnetism and Matter
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>
                                    IV - Electromagnetic Induction & Alternating
                                    Current
                                </h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 6 : Electromagnetic Induction
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 7 : Alternating Current
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>V - Electromagnetic Waves</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 8 : Electromagnetic Waves
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VI - Optics</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 9 : Ray Optics and Optical
                                    Instruments
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 10 : Wave Optics
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VII - Dual Nature of Matter</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 11 : Dual Nature of Radiation and
                                    Matter
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VIII - Atoms & Nuclei</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 12 : Atoms
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 13 : Nuclei
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>IX - Electronic Devices</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 14 : Semiconductor Electronics
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>X - Communication Systems</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Physics"
                                        id="ch-check"
                                    />
                                    Chapter - 15 : Communication Systems
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="subjects">
                        <h2>Chemistry</h2>
                        <div id="units">
                            <div id="chapters">
                                <h4>I - Solid State</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 1 : Solid State
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>II - Solutions</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 2 : Solutions
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>III - Electrochemistry</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 3 : Electrochemistry
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>IV - Chemical Kinetics</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 4 : Chemical Kinetics
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>V - Surface Chemistry</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 5 : Surface Chemistry
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VI - Isolation of Elements</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 6 : Isolation of Elements
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VII - p-Block Elements</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 7 : p-Block Elements
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VIII - d-and f-Block Elements</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 8 : d-and f-Block Elements
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>IX - Coordination Compounds</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 9 : Coordination Compounds
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>X - Haloalkanes and Haloarenes</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 10 : Haloalkanes and Haloarenes
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>XI - Alcohols, Phenols & Ethers</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 11 : Alcohols, Phenols & Ethers
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>
                                    XII - Aldhydes, Ketones & Carboxylic Acids
                                </h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 12 : Aldhydes, Ketones &
                                    Carboxylic Acids
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>
                                    XII - Organic Compounds containing Nitrogen
                                </h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 13 : Organic Compounds containing
                                    Nitrogen
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>XIV - Biomolecules</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 14 : Biomolecules
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>XV - Polymers</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 15 : Polymers
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>XVI - Chemistry in Everyday Life</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="Chemistry"
                                        id="ch-check"
                                    />
                                    Chapter - 16 : Chemistry in Everyday Life
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="subjects">
                        <h2>Maths</h2>
                        <div id="units">
                            <div id="chapters">
                                <h4>I - Relations and Functions</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 1 : Relations and Functions
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 2 : Inverse Trigonometric
                                    Functions
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>II - Algebra</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 3 : Algebra
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 4 : Determinants
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>III - Calculus</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 5 : Continuity and
                                    Differentiability
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 6 : Applications of Derivatives
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 7 : Integrals
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 8 : Applications of the Integrals
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 9 : Differential Equations
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>
                                    IV - Vectors and Three-Dimensional Geometry
                                </h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 10 : Vectors
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 11 : Three - dimensional Geometry
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>V - Linear Programming</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 12 : Linear Programming
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>VI - Probability</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 13 : Probability
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="subjects">
                        <h2>Biology</h2>
                        <div id="units">
                            <div id="chapters">
                                <h4>I - Reproduction</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 1 : Reproduction in Organisms
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 2 : Sexual Reproduction in
                                    Flowering Plants
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 3 : Human Reproduction
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 4 : Reproductive Health
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>II - Genetics and Evolution</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 5 : Principles of Inheritance and
                                    Variation
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 6 : Molecular Basis of Inheritance
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 7 : Evolution
                                </div>
                            </div>
                            <div id="chapters">
                                <h4>III - Biology and Human Welfare</h4>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 8 : Human Health and Diseases
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 9 : Strategies for Enhancement in
                                    Food Production
                                </div>
                                <div id="ch">
                                    <input
                                        type="checkbox"
                                        name="maths"
                                        id="ch-check"
                                    />
                                    Chapter - 10 : Microbes in Human Welfare
                                </div>
                                <div id="chapters">
                                    <h4>
                                        IV - Biotechnology and Its Applications
                                    </h4>
                                    <div id="ch">
                                        <input
                                            type="checkbox"
                                            name="maths"
                                            id="ch-check"
                                        />
                                        Chapter - 11 : Biotechnology -
                                        Principles and Processes
                                    </div>
                                    <div id="ch">
                                        <input
                                            type="checkbox"
                                            name="maths"
                                            id="ch-check"
                                        />
                                        Chapter - 12 : Biotechnology and its
                                        Application
                                    </div>
                                </div>
                                <div id="chapters">
                                    <h4>V - Ecology and Environment</h4>
                                    <div id="ch">
                                        <input
                                            type="checkbox"
                                            name="maths"
                                            id="ch-check"
                                        />
                                        Chapter - 13 : Organisms and Populations
                                    </div>
                                    <div id="ch">
                                        <input
                                            type="checkbox"
                                            name="maths"
                                            id="ch-check"
                                        />
                                        Chapter - 14 : Ecosystem
                                    </div>
                                    <div id="ch">
                                        <input
                                            type="checkbox"
                                            name="maths"
                                            id="ch-check"
                                        />
                                        Chapter - 15 : Biodiversity and its
                                        Conservation
                                    </div>
                                    <div id="ch">
                                        <input
                                            type="checkbox"
                                            name="maths"
                                            id="ch-check"
                                        />
                                        Chapter - 16 : Environmental Issues
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Roadmap;
